import React, { useEffect, useState } from "react";
import { getAllTransactions } from "../../../apis/ChargingHistoryApi";
import { useParams } from "react-router-dom";
import { Table } from "antd";
import getTransactionColumns from "../../../const/Columns/getTransactionColumns";

const ChargingHistory = () => {
  const { id } = useParams();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState(id || "");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  // const [status, setStatus] = useState("");
  const [type, setType] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await getAllTransactions({});
      setTransactions(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const filteredTransactions = transactions.filter((txn) => {
    const userName = [txn?.user?.firstName, txn?.user?.surname]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    const userEmail = (txn?.user?.email || "").toLowerCase();
    const userId = String(txn?.userId || "").toLowerCase();
    const typeText = (txn?.type || "").toLowerCase();
    const search = searchText.toLowerCase();

    const matchesSearch =
      !search ||
      userName.includes(search) ||
      userEmail.includes(search) ||
      userId.includes(search);

    const txnStartDate = txn?.startTime
      ? new Date(txn.startTime).toISOString().split("T")[0]
      : "";
    const matchesStartDate = !startTime || txnStartDate >= startTime;
    const matchesEndDate = !endTime || txnStartDate <= endTime;
    const matchesStatus = !type || typeText.includes(type.toLowerCase());

    return matchesSearch && matchesStartDate && matchesEndDate && matchesStatus;
  });

  const columns = getTransactionColumns();
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <div className="d-flex flex-column w-25">
                <label htmlFor="userIdInput" className="form-label">
                  User Name / Email
                </label>
                <input
                  type="text"
                  placeholder="Search by name or email"
                  className="form-control w-20"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="startDateInput" className="form-label">
                  Start Date
                </label>
                <input
                  type="date"
                  placeholder="Search with start date"
                  className="form-control w-20"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="endDateInput" className="form-label">
                  End Date
                </label>
                <input
                  type="date"
                  placeholder="Search with end date"
                  className="form-control w-20"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="typeFilter" className="form-label">
                  Type
                </label>
                <select
                  id="typeFilter"
                  className="form-control"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <option value="">All</option>
                  <option value="mobile">Virtual</option>
                  <option value="Physical">Physical</option>
                </select>
              </div>
              {/* <div className="d-flex flex-column w-25">
                <label htmlFor="statusInput" className="form-label">
                  Status
                </label>
                <input
                  type="text"
                  placeholder="Search with status"
                  className="form-control w-20"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                />
              </div> */}
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive" style={{ overflowX: "auto" }}>
                <Table
                  columns={columns}
                  dataSource={
                    filteredTransactions?.length > 0 ? filteredTransactions : []
                  }
                  className="table-striped "
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChargingHistory;
